import { MarketConfig } from './market-config';
import { EU_PLATE_COUNTRY_CODES } from './plate-country-codes';

/** Germany, Austria, Switzerland – the app as it is today (KfzDoku). Every value here is today's value. */
export const MARKET_DE: MarketConfig = {
  id: 'de',
  dataRegion: 'eu',
  currencyCode: 'EUR',
  preSelectedDistanceUnit: 'Kilometer',
  dateFormat: 'dd.MM.yyyy',
  firstDayOfWeek: 1,
  showHsnTsn: true,
  inspectionName: 'TÜV',
  inspectionNameFull: 'TÜV/AU',
  plate: {
    style: 'eu',
    preSelectedCountryCode: 'D',
    selectableCountryCodes: EU_PLATE_COUNTRY_CODES,
    hasRegionalCode: true,
    examplePlateText: 'XX 1234',
  },
};
